/**
 * Application config. The only module that reads `import.meta.env`.
 * Env → config → code. Missing required variables fail at import; there are no URL fallbacks.
 */

function required (name: string, value: string | undefined): string {
  const trimmed = value?.trim()
  if (!trimmed) {
    throw new Error(
      `Missing required environment variable: ${name}. ` +
        'For local dev, copy app/.env.example to .env.local. ' +
        'For production, set it as a build-time env var on the frontend service — Vite embeds values during `npm run build`.'
    )
  }
  return trimmed
}

function optional (value: string | undefined): string | undefined {
  const trimmed = value?.trim()
  return trimmed || undefined
}

export const config = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL).replace(/\/$/, ''),
  supabase: {
    url: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
    anonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY)
  },
  googleMapsApiKey: optional(import.meta.env.VITE_GOOGLE_MAPS_API_KEY),
  vapidPublicKey: optional(import.meta.env.VITE_VAPID_PUBLIC_KEY),
  superAdminEmail: optional(import.meta.env.VITE_SUPER_ADMIN_EMAIL),
  msg91WidgetId: optional(import.meta.env.VITE_MSG91_WIDGET_ID),
  msg91WidgetToken: optional(import.meta.env.VITE_MSG91_WIDGET_TOKEN),
  useMockApi: import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_API === 'true',
  isDev: import.meta.env.DEV as boolean
} as const
